<template>
  <el-dialog :width="pda.status ? '90%': '1000px'" :visible.sync="show" append-to-body>
    <div slot="title" class="dialog-title">
      <i class="el-icon-suitcase"></i>
      <!-- 器械问题登记 -->
      <span class="title-text">器械问题登记</span>
    </div>
    <div>
      <!-- 器械包名称 -->
      <label class="ml10">器械包名称</label><el-tag class="ml10">{{ detail.name }}</el-tag>
      <span v-if="detail.is_short_term > 0">
        <!-- 拆卸前件数 -->
        <label class="ml10">拆卸前总数</label><el-tag class="ml10">{{ detail.number_prev }}</el-tag>
      </span>
      <span>
        <!-- 拆卸后件数 : 器械件数 -->
        <label class="ml10">{{ detail.is_short_term > 0 ? `拆卸后总数` : `器械件数`}}</label><el-tag class="ml10">{{ detail.number}}</el-tag>
      </span>
      <span>
        <!-- 绑定科室 -->
        <label class="ml10">绑定科室</label><el-tag class="ml10">{{ detail.ins_department_name }}</el-tag>
      </span>
      <span v-if="detail.recycle_department_name">
        <!-- 回收科室 -->
        <label class="ml10">回收科室</label><el-tag class="ml10">{{ detail.recycle_department_name }}</el-tag>
      </span>
      <span v-if="detail.out_department_name">
        <!-- 发放科室 -->
        <label class="ml10">发放科室</label><el-tag class="ml10">{{ detail.out_department_name }}</el-tag>
      </span>
    </div>
    <div>
      <!-- 问题类型： -->
      <label class="ml10 mr10">问题类型</label>
      <el-select class="input150 mt10" v-model="sortType" @change="changeSort">
        <el-option
          v-for="item in sortTypes"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <!-- 包选择： -->
      <label class="ml10 mr10">器械包</label>
      <el-select class="input200 mt10" v-model="packageId" @change="changePackage">
        <el-option
          v-for="item in packages"
          :key="item.table_id"
          :label="item.name"
          :value="item.table_id">
        </el-option>
      </el-select>
    </div>
    <el-table
      stripe
      border
      v-show="sortType && packageId"
      :data="detail.instrument.filter(i => i.type !== 1)"
      style="width: 100%;"
      class="mt10">
      <!-- 物品名 -->
      <el-table-column
        :label="`物品名称`"
        prop="name"
        align="center">
      </el-table-column>
      <!-- 拆卸前数量 -->
      <el-table-column
        v-if="detail.is_short_term > 0"
        :label="`拆卸前总数`"
        align="center">
        <template slot-scope="scope">
          {{scope.row.number_prev}}
        </template>
      </el-table-column>
      <!-- 拆卸后数量:  数量-->
      <el-table-column
        v-if="detail.is_short_term > 0 ? detail.show_number === 1 : true"
        :label="detail.is_short_term > 0 ? `拆卸后总数` : `数量`"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.number }}
        </template>
      </el-table-column>
      <el-table-column v-for="(item, index) in questionTypes" :key="index" :label="item.name">
        <template slot-scope="scope">
          <span v-for="(p, i) in scope.row.problem" :key="i">
            <el-input-number v-if="item.id === p.id" class="input100" controls-position="right" v-model="p.number" :min="0" :max="calcMaxNumber(scope.row, p.id)"></el-input-number>
          </span>
        </template>
      </el-table-column>
      <!-- 部位 -->
      <el-table-column v-if="need_part" :label="`部位`" align="center">
        <template slot-scope="scope">
          <el-select v-if="showEdit(scope.row.problem) && scope.row.instrument_part_type && scope.row.instrument_part_type.length > 0" class="input100" v-model="scope.row.part_ids" multiple>
            <el-option
              v-for="item in (scope.row.instrument_part_type || [])"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <!-- 图片 -->
      <el-table-column
        v-if="need_image"
        :label="`图片`"
        align="center">
        <template slot-scope="scope">
          <span v-if="showEdit(scope.row.problem)">
            <span v-for="(i, index) in scope.row.files" :key="index" style="width: 40px;height: 40px;overflow: hidden;display:inline-block;">
              <el-image class="cover" :src="i.url || defaultImg" :preview-src-list="(scope.row.files ? scope.row.files : []).map(s => s.url)"></el-image>
            </span>
            <br />
            <!-- 拍照 -->
            <el-button type="primary" size="mini" @click="photo(scope.row)">拍照</el-button>
          </span>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        :label="`备注`"
        align="center">
        <template slot-scope="scope">
          <el-input v-if="showEdit(scope.row.problem)" class="input90" v-model="scope.row.remark"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div class="d-flex right mt10">
      <!-- 确 定 -->
      <el-button type="primary" size="mini" @click="confirm()">确定</el-button>
      <!-- 取 消 -->
      <el-button size="mini" @click="close()">取消</el-button>
    </div>
    <PictureSelect ref="pictureSelect" @complete="getPicture" />
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { getPackageDetail, instrumentQuestionTypes, processPackages, processQuestionDetail } from '@/api.js'
export default {
  name: 'QuestionRecord',
  data() {
    return {
      show: false,
      process: '', // 流程节点
      process_id: [], // 流程节点id
      need_part: false,
      need_image: false,
      handleItem: null,
      sortType: null,
      packageId: null,
      packages: [],
      sortTypes: [],
      allProblems: [],
      questionTypes: [],
      detail: {
        instrument: []
      }
    }
  },
  computed: {
    ...mapGetters(['exec', 'pda'])
  },
  methods: {
    calcMaxNumber(item, pId) {
      // 计算最大数量
      const total = item.number + (item.number_prev || 0)
      let left = total

      this.questionTypes.forEach(i => {
        item.problem.forEach(p => {
          if (i.id === p.id && p.id !== pId) {
            left -= (p.number || 0)
          }
        })
      })

      return left
    },
    showEdit(problem = []) {
      // 根据器械的已登机数量显示图片和部位
      let count = 0
      this.questionTypes.forEach(i => {
        problem.forEach(p => {
          if (i.id === p.id) {
            count += (p.number || 0)
          }
        })
      })

      return count > 0
    },
    reset() {
      // 数据重置
      this.process = ''
      this.process_id = []
      this.need_part = false
      this.need_image = false
      this.handleItem = null
      this.sortType = null
      this.packageId = null
      this.packages = []
      this.sortTypes = []
      this.allProblems = []
      this.questionTypes = []
      this.detail = {
        instrument: []
      }
    },
    async open(info) {
      this.reset()
      const { instrumentset_id, process, process_id, inner_code, udi_node } = info
      this.process = process
      this.process_id = process_id
      this.getInstrumentQuestionTypes()
      this.getPackages()
      const detail = await this.getPackageDetail(instrumentset_id, inner_code, udi_node)
      if (detail) {
        this.detail = detail
        
        this.show = true
      }
    },
    getInstrumentQuestionTypes() {
      // 获取问题类型
      const query = {
        type: 1,
        node: this.process
      }
      return this.$request('get', instrumentQuestionTypes, query)
      .then((res) => {
        this.sortTypes = res || []
        let questionTypes = []
        this.sortTypes.forEach(s => {
          questionTypes = questionTypes.concat(s.son || [])
        })
        this.allProblems = questionTypes.map(i => {return {id: i.id}})
      })
    },
    getPackages() {
      // 获取包
      const query = {
        type: 1,
        node: this.process,
        table_ids: this.process_id
      }
      return this.$request('get', processPackages, query)
      .then((res) => {
        this.packages = res || []
      })
    },
    changeSort() {
      // 切换
      const item = this.sortTypes.filter(i => i.id === this.sortType)[0]
      const { son, need_part, need_image } = item
      this.questionTypes = son
      this.need_part = need_part === 1
      this.need_image = need_image === 1

      this.getQuestionDetail()
    },
    changePackage() {
      // 切换包
      const item = this.packages.filter(i => i.table_id === this.packageId)[0]
      if (item) {
        const { ins_department_name, out_department_name, recycle_department_name } = item
        this.$set(this.detail, 'ins_department_name', ins_department_name)
        this.$set(this.detail, 'out_department_name', out_department_name)
        this.$set(this.detail, 'recycle_department_name', recycle_department_name)
      }

      this.getQuestionDetail()
    },
    getQuestionDetail() {
      // 获取问题详情
      if (!this.sortType) {
        // this.$message.error('请选择问题类型')
        this.$message.error(`问题类型不能为空`)
        return
      }

      const query = {
        type: 1,
        node: this.process,
        problem_parent_id: this.sortType,
        table_id: this.packageId
      }
      return this.$request('get', processQuestionDetail, query)
      .then((res) => {
        // 处理问题详情
        this.detail.instrument.forEach(i => {
          const pData = []
          let files = []
          let remark = ''
          let part_ids = []
          this.allProblems.forEach(i => {
            pData.push({
              id: i.id,
              number: 0
            })
          });

          (res || []).forEach(p => {
            if (i.id === p.instrument_id) {
              files = p.files
              remark = p.remark
              part_ids = p.part_ids

              pData.forEach(i => {
                (p.problem || []).forEach(pi => {
                  if (pi.id === i.id) {
                    i.number = pi.number
                  }
                })
              })
            }
          })

          this.$set(i, 'problem', pData)
          this.$set(i, 'files', files)
          this.$set(i, 'remark', remark)
          this.$set(i, 'part_ids', part_ids)
        })
      })
    },
    getPackageDetail(code, inner_code = undefined, udi_node = undefined) {
      // 获取包详情
      const url = getPackageDetail.replace('{id}', inner_code || code)
      return this.$request('get', url, { udi_node, recycle_id: this.process_id[0] })
      .then((res) => {
        if (res) {
          return res
        }

        return null
      })
    },
    photo(item) {
      this.handleItem = item

      this.$refs.pictureSelect.show()
    },
    getPicture(pictures) {
      const list = pictures.map(i => {return { id: i.fileId, url: i.fileUrl}})
      const images = (this.handleItem.files || []).concat(list)
      this.$set(this.handleItem, 'files', images)
    },
    handlePostProblem(problem) {
      // 处理需要提交的问题数据
      const data = []
      this.questionTypes.forEach(i => {
        if (problem.filter(p => p.id === i.id).length === 1) {
          const item = problem.filter(p => p.id === i.id)[0]
          data.push({
            id: item.id,
            number: item.number || 0
          })
        } else {
          data.push({
            id: i.id,
            number: 0
          })
        }
      })

      return data
    },
    confirm() {
      // 问题登记保存
      if (!this.sortType) {
        // this.$message.error('请选择问题类型')
        this.$message.error(`问题类型不能为空`)
        return
      }

      if (!this.packageId) {
        // this.$message.error('请选择包')
        this.$message.error(`器械包不能为空`)
        return
      }

      const instruments = []
      let partCheck = false
      this.detail.instrument.forEach(i => {
        const problemData = this.handlePostProblem(i.problem || [])
        const parts = i.part_ids || []
        const dataItem = {
          part_ids: parts,
          part_names: i.instrument_part_type.filter(t => parts.includes(t.id)).map(n => n.name),
          instrument_id: i.id,
          instrument_name: i.name,
          instrument_abc_code: i.abc_code,
          remark: i.remark || '',
          file_id: (i.files || []).map(i => i.id),
          problem: problemData,
          instrument_udi: i.udi
        }

        if (this.need_part && i.instrument_part_type && i.instrument_part_type.length > 0) {
          const problems = problemData.map(i => i.number)
          const problemSum = problems.reduce((a, b) => a + b)
          if (problemSum > 0 && parts.length === 0) {
            partCheck = true
          }
        }

        instruments.push(dataItem)
      })

      if (partCheck) {
        // this.$message.error('部位不可为空')
        this.$message.error(`部位不能为空`)
        return
      }

      const params = {
        type: 1,
        node: this.process,
        table_id: this.packageId,
        problem_parent_id: this.sortType,
        instruments
      }
      this.$request('post', processQuestionDetail, params)
      .then((res) => {
        if (res) {
          // this.$message.success('登记成功')
          this.$message.success(`登记成功`)
          this.$emit('done')
          this.close()
        }
      })
    },
    close() {
      this.show = false
    }
  }
}
</script>
<style>

</style>